import React, { FC } from "react";

import { FormattedNumber } from "@I18n/Components/FormattedNumber/FormattedNumber";
import { IAppCurrency } from "@App/types";

export type RateProps = {
  cents: number;
  currency: IAppCurrency;
};

export const Money: FC<RateProps> = ({ cents, currency }) => {
  return (
    <FormattedNumber
      value={cents / 100}
      style="currency"
      currency={currency}
      minimumFractionDigits={0}
    />
  );
};
